const state = {
  all: [],
  product: null,
  destacados: null
}

export default state
